import {SellerError} from './SellerError.js'

export class GetCloseDealersGenericSellerError extends SellerError {}
